// client/src/components/ShoppingList.jsx - Liste de courses
import React, { useState } from 'react';
import { markItemsAsPurchased, updateShoppingList } from '../api/shoppingApi';

const ShoppingList = ({ shoppingList, onUpdate }) => {
  const [editMode, setEditMode] = useState(false);
  const [updatedItems, setUpdatedItems] = useState(shoppingList.items);
  
  const handleTogglePurchased = async (item) => {
    try {
      if (editMode) {
        const updated = updatedItems.map((i) => 
          i._id === item._id ? { ...i, purchased: !i.purchased } : i
        );
        setUpdatedItems(updated);
      } else {
        await markItemsAsPurchased(shoppingList._id, [item._id]);
        onUpdate();
      }
    } catch (error) {
      console.error('Erreur lors du marquage de l\'article:', error);
    }
  };
  
  const handleQuantityChange = (itemId, newQuantity) => {
    const updated = updatedItems.map((item) => 
      item._id === itemId ? { ...item, quantity: Number(newQuantity) } : item
    );
    setUpdatedItems(updated);
  };
  
  const handleSaveChanges = async () => {
    try {
      await updateShoppingList(shoppingList._id, { items: updatedItems });
      setEditMode(false);
      onUpdate();
    } catch (error) {
      console.error('Erreur lors de la mise à jour de la liste de courses:', error);
    }
  };
  
  const handleCancelChanges = () => {
    setUpdatedItems(shoppingList.items);
    setEditMode(false);
  };
  
  const groupedItems = {};
  
  (editMode ? updatedItems : shoppingList.items).forEach((item) => {
    if (!groupedItems[item.category]) {
      groupedItems[item.category] = [];
    }
    groupedItems[item.category].push(item);
  });
  
  return (
    <div className="bg-white rounded-2xl shadow-xl border border-gray-100">
      <div className="p-6">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-semibold" style={{ color: '#2C3E50' }}>Liste de courses</h2>
          
          <div>
            {editMode ? (
              <div className="flex space-x-2">
                <button
                  onClick={handleSaveChanges}
                  className="px-4 py-2 text-white rounded-full hover:opacity-90 transition-all"
                  style={{ backgroundColor: '#87A96B' }}
                >
                  Enregistrer
                </button>
                <button
                  onClick={handleCancelChanges}
                  className="px-4 py-2 bg-gray-200 rounded-full hover:bg-gray-300 transition-all"
                  style={{ color: '#2C3E50' }}
                >
                  Annuler
                </button>
              </div>
            ) : (
              <button
                onClick={() => setEditMode(true)}
                className="px-4 py-2 text-white rounded-full hover:opacity-90 transition-all"
                style={{ backgroundColor: '#E67E22' }}
              >
                Modifier
              </button>
            )}
          </div>
        </div>
        
        <div className="space-y-6">
          {Object.entries(groupedItems).map(([category, items]) => (
            <div key={category}>
              <h3 className="text-lg font-medium capitalize mb-3 border-b pb-2" style={{ color: '#2C3E50' }}>
                {category}
              </h3>
              
              <ul className="space-y-2">
                {items.map((item) => (
                  <li
                    key={item._id}
                    className={`flex items-center justify-between p-3 rounded-xl transition-all ${
                      item.purchased ? 'bg-gray-50' : 'bg-white border border-gray-100'
                    }`}
                  >
                    <div className="flex items-center">
                      <input
                        type="checkbox"
                        checked={item.purchased}
                        onChange={() => handleTogglePurchased(item)}
                        className="mr-3 h-5 w-5 rounded focus:ring-2"
                        style={{ accentColor: '#87A96B' }}
                      />
                      
                      <span
                        className={`${
                          item.purchased ? 'line-through' : ''
                        }`}
                        style={{ color: item.purchased ? '#6c757d' : '#2C3E50' }}
                      >
                        {item.name}
                      </span>
                    </div>
                    
                    <div className="flex items-center">
                      {editMode ? (
                        <input
                          type="number"
                          min="1"
                          value={item.quantity}
                          onChange={(e) => handleQuantityChange(item._id, e.target.value)}
                          className="w-16 p-2 mr-2 border border-gray-200 rounded-lg text-center focus:ring-2"
                          style={{ accentColor: '#87A96B' }}
                        />
                      ) : (
                        <span className="mr-2" style={{ color: '#6c757d' }}>
                          {item.quantity}
                        </span>
                      )}
                      
                      <span style={{ color: '#6c757d' }}>
                        {item.unit}
                      </span>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        
        <div className="mt-8 pt-6 border-t border-gray-200">
          <div className="flex justify-between text-lg">
            <span style={{ color: '#2C3E50' }}>Total:</span>
            <span style={{ color: '#2C3E50' }}>{shoppingList.items.length} articles</span>
          </div>
          <div className="flex justify-between" style={{ color: '#6c757d' }}>
            <span>Achetés:</span>
            <span>
              {shoppingList.items.filter((item) => item.purchased).length} articles
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShoppingList;